import { ActionTypes } from "../constants/action-types";

const initialState = {
    CollaborationImageStaus:[],
};
//
export const UploadCollaborationImage = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.UPLOAD_COLLABORATION_IMAGE:
      return { ...state, CollaborationImageStaus: payload };
    default:
      return state;
  }
};